import api, { publicApi } from '../api';
import { Recurso, StatusRecurso } from '../model/Candidato/Recurso';


export default class RecursoViewModel {

    static async obterRecursosPendentes(): Promise<Recurso[]> {
        try {
            const response = await api.get<Recurso[]>('/recursos/pendentes');
            return response.data.map(this.formatarRecurso);
        } catch (error) {
            console.error('Erro ao obter recursos pendentes', error);
            throw error;
        }
    }

    static async atualizarStatusRecurso(recursoId: string, status: string): Promise<Recurso> {
        try {
            const dadosParaEnvio = {
                status: status
            };
            const response = await api.patch<Recurso>(`/candidatos/recursos/${recursoId}/status`, dadosParaEnvio);

            if (response.status >= 200 && response.status < 300) {
                return this.formatarRecurso(response.data);
            } else {
                throw new Error(`Erro ao atualizar status do recurso: ${response.statusText}`);
            }
        } catch (error) {
            console.error('Erro ao atualizar status do recurso:', error);
            throw error;
        }
    }


    static async obterRecursoPorId(recursoId: string): Promise<Recurso> {
        try {
            const response = await api.get<Recurso>(`/candidatos/recursos/${recursoId}`);

            if (response.status >= 200 && response.status < 300) {
                return this.formatarRecurso(response.data);
            } else {
                throw new Error(`Erro ao obter recurso: ${response.statusText}`);
            }
        } catch (error) {
            console.error('Erro ao obter recurso:', error);
            throw error;
        }
    }

    static async criarRecurso(texto: string, candidatoBancaId: string, cpf: string, passaporte: string, token: string): Promise<Recurso> {
        try {
            const dadosParaEnvio = {
                texto: texto,
                candidatoBancaId: candidatoBancaId,                
                cpf: cpf,
                passaporte: passaporte
            };

            const response = await publicApi.post<Recurso>(`/candidatos/recursos?token=${token}`, dadosParaEnvio);

            if (response.status >= 200 && response.status < 300) {
                return this.formatarRecurso(response.data);
            } else {
                throw new Error(`Erro ao criar recurso: ${response.statusText}`);
            }
        } catch (error) {
            console.error('Erro ao criar recurso:', error);
            throw error;
        }
    }
    static async getRecursos(bancaId: string, status?: StatusRecurso): Promise<Recurso[]> {
        try {
            const query = status ? `?status=${status}` : '';
            const response = await api.get<Recurso[]>(`/bancas/${bancaId}/recursos${query}`);

            if (response.status >= 200 && response.status < 300) {
                return response.data.map(this.formatarRecurso);
            } else {
                throw new Error(`Erro ao obter recursos: ${response.statusText}`);
            }
        } catch (error) {
            console.error('Erro ao obter recursos:', error);
            throw error;
        }
    }
    static async getRecursosCompleto(bancaId: string, status?: StatusRecurso): Promise<Recurso[]> {
        try {
            const query = status ? `?status=${status}` : '';
            const response = await api.get<Recurso[]>(`/bancas/${bancaId}/recursos${query}`);

            if (response.status >= 200 && response.status < 300) {
                return response.data.map(this.formatarRecurso);
            } else {
                throw new Error(`Erro ao obter recursos: ${response.statusText}`);
            }
        } catch (error) {
            console.error('Erro ao obter recursos:', error);
            throw error;
        }
    }

    private static formatarRecurso(data: any): Recurso {
        return {
            id: data.id,
            texto: data.texto,
            dataCriacao: data.dataCriacao,
            status: StatusRecurso[data.status as keyof typeof StatusRecurso],
            candidatoId: data.candidatoBancaId,
            bancaId: data.bancaId,
            nomeCandidato: data.nomeCandidato,
            candidatoInscricao: data.candidatoInscricao,
            candidatoEditais: data.candidatoEditais,
        };
    }
}